import { render, staticRenderFns } from "./BillingDetailsCard.vue?vue&type=template&id=ee243b64&"
import script from "./BillingDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./BillingDetailsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports